import { StructureBlockSubject as StructureBlockSubjectBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import StructureBlockSubjectNodeView from '@/components/editor/StructureBlockSubjectNodeView'

export const StructureBlockSubject = StructureBlockSubjectBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(StructureBlockSubjectNodeView)
    },
})
